import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import LoadingComponent from "./loading";

export default function Logout() {
  const navigate = useNavigate();
  
  // Move the hook to the top level of the component
  const user = useContext(AuthContext);

  const userId = user.id
  
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const postStaff = async () => {
      setLoading(true);
            try {
        const response = await fetch(`https://api.insightos.co.uk/admin/logout/${userId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: 'include',

          body: JSON.stringify({ user }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error logging out:", error);
      } finally {
        setLoading(false);
        // reload the page to reflect logout
        window.location.reload();
        navigate("/");
      }
    };

    postStaff();
  }, [navigate, user]);

  return <>{loading ? <LoadingComponent /> : null}</>;
}
